import { render } from "./GamificationContextPanel.vue?vue&type=template&id=50845bcf&ts=true"
import script from "./GamificationContextPanel.vue?vue&type=script&lang=ts"
export * from "./GamificationContextPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__